import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/your-privacy-choices/page.js");
